import { render, staticRenderFns } from "./DownToCloseDialog.vue?vue&type=template&id=801f9cbe"
import script from "./DownToCloseDialog.vue?vue&type=script&lang=js"
export * from "./DownToCloseDialog.vue?vue&type=script&lang=js"
import style0 from "./DownToCloseDialog.vue?vue&type=style&index=0&id=801f9cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports